var React = require('react');

function CaretSquareDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-51.37 182.31L232.06 348.16a10.38 10.38 0 0 1-16.12 0L99.37 214.31C92.17 206 97.28 192 107.43 192h233.14c10.15 0 15.26 14 8.06 22.31z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M348.63 214.31L232.06 348.16a10.38 10.38 0 0 1-16.12 0L99.37 214.31C92.17 206 97.28 192 107.43 192h233.14c10.15 0 15.26 14 8.06 22.31z","className":"fa-primary","key":2})]);
}

CaretSquareDown.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = CaretSquareDown;

CaretSquareDown.default = CaretSquareDown;
